import { LinkTypes } from "src/contexts/_shared/domain/LinkType";
import { CoreHTTPBaseRepository } from "src/contexts/_shared/infrastructure/core/CoreHTTPBaseRepository";
import { TranslationRepository } from "src/contexts/translation/domain/TranslationRepository";
import { LocaleConfig } from "../domain/LocaleConfig";
import { DocumentationAreaId } from "src/contexts/documentationArea/domain/DocumentationAreaId";
import { ActorId } from "src/contexts/documentationArea/domain/ActorId";

export class HTTPTranslationRepository
  extends CoreHTTPBaseRepository
  implements TranslationRepository
{
  public getTranslations = async (locale: string, slug: string, linkType: LinkTypes) => {
    const response = await this.request<Record<string, string>>({
      method: "GET",
      url: `/translation`,
      headers: { "accept-language": locale },
      params: { slug, linkType },
    });
    return response;
  };

  public getTranslationsByDocumentationAreaId = async (
    locale: string,
    documentationAreaId: DocumentationAreaId,
    accessToken: string,
  ) => {
    const response = await this.request<Record<string, string>>({
      method: "GET",
      url: `/translation`,
      headers: { "accept-language": locale, Authorization: `Bearer ${accessToken}` },
      params: { id: documentationAreaId },
    });
    return response;
  };

  public getLocaleConfig = async (slug: string, linkType: LinkTypes) => {
    const response = await this.request<LocaleConfig>({
      method: "GET",
      url: `/internal/documentation-area/locale-config`,
      params: { slug, linkType },
    });
    return response;
  };

  public getLocaleConfigByDocumentationAreaId = async (
    documentationAreaId: DocumentationAreaId,
    actorId: ActorId,
    accessToken: string,
  ) => {
    const response = await this.request<LocaleConfig>({
      method: "GET",
      url: `/internal/documentation-area/${documentationAreaId}/actor/${actorId}/locale-config`,
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    return response;
  };
}
